'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.loadBalancer.details.openstack', [
  require('./details.controller.js').name,
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/openstack/src/loadBalancer/details/details.openstack.module.js